module.exports = __webpack_public_path__ + "static/11-f912e2fb89dcd4cc43a2565334ecde80.jpg";